import { create } from "zustand";

const ZustandDadosDeFinanciamento = create((set, get) => ({
    taxaBrb: 0,
    taxaBradesco: 0, 
    taxaCaixa: 0, 
    taxaInter: 0,
    taxaSantander: 0,
    taxaItau: 0, 

    setTaxaBrb: (value) => set({ taxaBrb: parseFloat(value) || 0 }),
    setTaxaBradesco: (value) => set({ taxaBradesco: parseFloat(value) || 0 }),
    setTaxaCaixa: (value) => set({ taxaCaixa: parseFloat(value) || 0 }),
    setTaxaInter: (value) => set({ taxaInter: parseFloat(value) || 0 }),
    setTaxaSantander: (value) => set({ taxaSantander: parseFloat(value) || 0 }),
    setTaxaItau: (value) => set({ taxaItau: parseFloat(value) || 0 }),


}));

export default ZustandDadosDeFinanciamento;
